<template>
    <div class="sidebar-user">
        <template v-if="isLoggedIn">
            <div class="sidebar-user__user">
                <img
                    src="/shared-img/mobile-menu-component/person-placeholder.svg"
                    width="40"
                    height="40"
                    alt="Avatar"
                />
                <div class="sidebar-user__name">
                    <span>{{ userName }}</span>
                    <div class="sidebar-user__balance">
                        <button @click="headerStore.displayBalance = !headerStore.displayBalance">
                            <SvgIcon :name="headerStore.displayBalance ? 'hide' : 'show'" />
                        </button>
                        <span class="sidebar-user__balance-amount" v-show="headerStore.displayBalance">
                            {{ balance?.DisplayBalance }}
                        </span>
                    </div>
                </div>
            </div>
            <Button @click="clickDeposit">Vložit</Button>
        </template>
        <template v-else>
            <Button @click="showLogin">Přihlásit</Button>
            <a
                :href="registrationLink"
                class="button button--secondary button--size-m button--theme-blue button--secondary button--caps"
            >
                <div class="button__content">Vytvořit účet</div>
            </a>
        </template>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import SvgIcon from "@/shared/components/atoms/SvgIcon.vue";
import Button from "@/shared/components/atoms/Button.vue";

import { useNgSession } from "@/shared/ng/ng-session";

import { ngFrameworkLoaded } from "@/shared/ng/ng-integration";
import { useHeader } from "@/shared/stores/use-header";
import { logException } from "@/shared/utils/logger/use-app-logger";

const { isLoggedIn, balance, session } = useNgSession();
const headerStore = useHeader();

const userName = computed(() => {
    if (!isLoggedIn.value) return "";

    const nameLength = session.value.PlayerName.length + session.value.PlayerLastName?.length;

    if (nameLength > 25) {
        const firstName = `${session.value.PlayerName[0]}.`;

        return `${firstName} ${session.value?.PlayerLastName}`;
    } else {
        return `${session.value.PlayerName} ${session.value?.PlayerLastName}`;
    }
});

const clickDeposit = async () => {
    headerStore.sidebarOpen = false;

    try {
        await ngFrameworkLoaded();

        ng_fw.showDeposit();
    } catch (error) {
        logException("sidebar", error, { message: "An error has occurred while opening Deposit" });
    }
};

const showLogin = async () => {
    headerStore.sidebarOpen = false;

    try {
        await ngFrameworkLoaded();

        ng_fw.showLogin();
    } catch (error) {
        logException("sidebar", error, { message: "An error has occurred while opening Login" });
    }
};

const registrationLink = `${environment.portalBaseUrl}/registrace?returnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`;
</script>
